import React from "react";
import { IIcons } from "./icons";

const Editable = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.76316 3.07895L0 11.8421V15H3.15789L11.9211 6.23684L8.76316 3.07895ZM9.94737 1.89474L11.8421 0L15 3.15789L13.1053 5.05263L9.94737 1.89474Z"
        fill="#ACACAC"
      />
    </svg>
  );
};

export default Editable;
